import { StyledOrdersDrawer } from '../style';
import { Transaction } from '../../../../interfaces/BackendModels';
import { OrderStatus } from './OrderStatus/OrderStatus';
import { OrderItemsTable } from './OrderItemsTable/OrderItemsTable';
import { OrderInvoiceBase } from './OrderInvoiceBase/OrderInvoiceBase';
import { useIntl } from 'react-intl';
import useQueryApiClient from '../../../../utils/useQueryApiClient';
import { Button, Spinner } from 'ui';
import { message } from 'antd';
import useFarmOrderHandler from 'hooks/useFarmOrderHandler';

interface OrdersViewOrderProps {
  transaction?: Transaction | null | any;
  open?: boolean;
  onClose?: () => void;
  reloadPage?: number;
  setReload?: React.Dispatch<React.SetStateAction<number>>;
  refetchTransaction?: Function;
  showActionButton?: boolean;
}

export const OrdersViewOrder = ({
  transaction,
  onClose,
  open,
  reloadPage,
  setReload,
  refetchTransaction,
  showActionButton = false,
}: OrdersViewOrderProps) => {
  const intl = useIntl();
  const { handleDownloadClick, pdfLoading } = useFarmOrderHandler();

  const { appendData: changeStatus } = useQueryApiClient({
    request: {
      url: `api/v2/transactions/change-status`,
      method: 'POST',
    },
    onSuccess: () => {
      message.success(intl.formatMessage({ id: 'form.succesfuly_updated' }));
      if (reloadPage && setReload) {
        setReload(reloadPage + 1);
      }

      refetchTransaction &&
        refetchTransaction({}, { transactionId: transaction.id });
    },
  });

  const renderButton = () => {
    if (!showActionButton) {
      return <></>;
    }

    switch (transaction?.status) {
      case 'new':
        return (
          <Button
            label={intl.formatMessage({ id: 'orders.confirm' })}
            type="primary"
            onClick={() =>
              changeStatus({
                status: 'confirmed',
                id: transaction.id,
              })
            }
          />
        );
      case 'confirmed':
        return (
          <Button
            label={intl.formatMessage({ id: 'orders.send_orders' })}
            type="primary"
            onClick={() =>
              changeStatus({
                status: 'sent',
                id: transaction.id,
              })
            }
          />
        );
      case 'sent':
        return (
          <Button
            label={intl.formatMessage({ id: 'orders.delivered' })}
            type="primary"
            onClick={() =>
              changeStatus({
                status: 'delivered',
                id: transaction.id,
              })
            }
          />
        );
    }
  };

  return (
    <StyledOrdersDrawer
      open={open}
      onClose={onClose}
      width={923}
      footer={
        <div className="footer-container">
          <Button
            label={
              <Spinner spinning={pdfLoading}>
                {intl.formatMessage({ id: 'orders.download' })}
              </Spinner>
            }
            onClick={() => {
              let downloadData;
              if (transaction?.transactions) {
                downloadData = transaction?.transactions?.map((data: any) => ({
                  order_id: data.order_id,
                  farm_id: data.farm_id,
                }));
              } else {
                downloadData = [
                  {
                    order_id: transaction?.order_id,
                    farm_id: transaction?.farm_id,
                  },
                ];
              }

              handleDownloadClick(downloadData);
            }}
          />
          {renderButton()}
        </div>
      }
    >
      <OrderStatus transactionStatus={transaction?.status ?? 'new'} />
      <OrderItemsTable products={transaction?.items ?? []} />
      <div className={'content-invoice'}>
        {transaction?.transactions ? (
          transaction?.transactions?.map((trans: any) => {
            return <OrderInvoiceBase transaction={trans} order={transaction} />;
          })
        ) : (
          <OrderInvoiceBase transaction={transaction} />
        )}
      </div>
    </StyledOrdersDrawer>
  );
};
